import { createContext } from "react";

export type SiteConfigQuery = {
  trackEventName: string;
  domain: string;
  shareImg: string;
  shareTitle: string;
  weiboShareDesc: string;
  wxShareDesc: string;
  activityId: string;
  home_page: {
    game_download_url: string;
    taobao_url: string;
    show_taobao: boolean;
    minigameUrl: string;
  };
  loading_page: {
    loadingBgColor: string;
    loadingPrimaryColor: string;
  };
  activityConfig: {
    startTs: number;
    endTs: number;
    shopModuleConfig: Array<{
      sku: string;
      type: number;
      name: string;
      cover: string;
      price: number;
      limit: number;
      extraArg: any;
    }>;
    checkInModuleConfig: {
      total: number;
    };
  };
};

export const SiteConfigContext = createContext<SiteConfigQuery|null>(null);
SiteConfigContext.displayName = "SiteConfigContext";
